import React, { useState } from "react";
import "./EmployeeRegistration.css"; // ✅ Import CSS
import { registerEmployee } from "../../services/employeeService"; // ✅ API Call
import Popup from "../../components/ui/Popup"; // ✅ Success/Error Popup

const EmployeeRegistration = ({ isOpen, onClose, onEmployeeAdded }) => {
    const [employeeData, setEmployeeData] = useState({
        nic: "",
        firstName: "",
        lastName: "",
        dob: "",
        gender: "",
        address: "",
        contactNumber: "",
        joinedDate: "",
        position: "",
        statusId: 1, // ✅ Default active status
    });

    const [showPopup, setShowPopup] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");

    // ✅ Handle Input Change
    const handleChange = (e) => {
        setEmployeeData({ ...employeeData, [e.target.name]: e.target.value });
    };

    // ✅ Validate Form Fields
    const validateForm = () => {
        const errorMessages = [];

        if (!(employeeData.nic || "").trim()) errorMessages.push("❌ NIC is required.");
        if (!(employeeData.firstName || "").trim()) errorMessages.push("❌ First Name is required.");
        if (!(employeeData.lastName || "").trim()) errorMessages.push("❌ Last Name is required.");
        if (!employeeData.dob) errorMessages.push("❌ Date of Birth is required.");
        if (!employeeData.gender) errorMessages.push("❌ Gender is required.");
        if (!(employeeData.address || "").trim()) errorMessages.push("❌ Address is required.");
        if (!(employeeData.contactNumber || "").trim()) errorMessages.push("❌ Contact Number is required.");
        if (!employeeData.joinedDate) errorMessages.push("❌ Joining Date is required.");
        if (!(employeeData.position || "").trim()) errorMessages.push("❌ Position is required.");

        if (errorMessages.length > 0) {
            setPopupMessage(errorMessages.join("\n")); // ✅ Show all errors in the popup
            setShowPopup(true);
        }

        return errorMessages.length === 0; // ✅ Return validation result
    };

    // ✅ Handle Form Submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return; // ✅ Show validation errors in popup but continue execution

        try {
            await registerEmployee(employeeData);
            setPopupMessage("Employee registered successfully!");
            setShowPopup(true);

            setTimeout(() => {
                setShowPopup(false);
                onClose();
                onEmployeeAdded(); // ✅ Refresh employee list
            }, 2000);
        } catch (error) {
            setPopupMessage(error.message || "Registration failed!");
            setShowPopup(true);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="employee-modal">
            <div className="employee-modal-content">
                <button className="employee-close-btn" onClick={onClose}>✕</button>
                <h2>Register Employee</h2>

                <form onSubmit={handleSubmit}>
                    <div className="employee-form-group">
                        <label>Employee NIC:</label>
                        <input type="text" name="nic" value={employeeData.nic} onChange={handleChange} />
                    </div>

                    <div className="employee-form-row">
                        <div className="employee-form-group">
                            <label>First Name:</label>
                            <input type="text" name="firstName" value={employeeData.firstName} onChange={handleChange} />
                        </div>
                        <div className="employee-form-group">
                            <label>Last Name:</label>
                            <input type="text" name="lastName" value={employeeData.lastName} onChange={handleChange} />
                        </div>
                    </div>

                    <div className="employee-form-row">
                        <div className="employee-form-group">
                            <label>Date of Birth:</label>
                            <input type="date" name="dob" value={employeeData.dob} onChange={handleChange} />
                        </div>
                        <div className="employee-form-group">
                            <label>Gender:</label>
                            <select name="gender" value={employeeData.gender} onChange={handleChange}>
                                <option value="">Select</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                            </select>
                        </div>
                    </div>

                    <div className="employee-form-group">
                        <label>Address:</label>
                        <input type="text" name="address" value={employeeData.address} onChange={handleChange} />
                    </div>

                    <div className="employee-form-row">
                        <div className="employee-form-group">
                            <label>Contact Number:</label>
                            <input
                                type="text"
                                name="contactNumber"
                                value={employeeData.contactNumber}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="employee-form-group">
                            <label>Joining Date:</label>
                            <input
                                type="date"
                                name="joinedDate"
                                value={employeeData.joinedDate}
                                onChange={handleChange}
                            />
                        </div>
                    </div>


                    <div className="employee-form-group">
                        <label>Position:</label>
                        <input type="text" name="position" value={employeeData.position} onChange={handleChange} />
                    </div>

                    <button type="submit" className="employee-register-btn">Register</button>
                </form>
            </div>

            {/* ✅ Popup Notification for Validation Errors & Success Messages */}
            {showPopup && <Popup message={popupMessage} onClose={() => setShowPopup(false)} />}
        </div>
    );
};

export default EmployeeRegistration;
